<template>
    <div :class="wrapClass" style="width: 100%; height: 100%">
        <div :class="innerClass" style="width: 100%; height: 100%; overflow: hidden;" id="simple-map" ref="simple-map"></div>
    </div>
</template>

<script>
import {$_WC, $_TYPE} from '@/confs/common.const.js';
import GripGeoJsonSimpleMap from "@/libs/grip.simplemap.js";

export default {
    name: "Simplemap",
    props: {
        wrapClass: {
            type: String,
            default: 'simple_map_wrap'
        },
        innerClass: {
            type: String,
            default: 'simple_map'
        },
        gejsonUrl: {
            type: String,
            required: false,
            default: $_WC.assets + 'geojson/adarea/' + $_WC.geojsonPath + '/emd.json',
        },
        keyProp: {
            type: String,
            default: 'adm_code',
        },
        nameProp: {
            type: String,
            default: 'name',
        },
        center: {
            type: Array,
            required: false,
        },
        mapScale: {
            type: Number,
            default: 1.0
        }
    },
    watch: {
        gejsonUrl: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.drawSimplemap();
            }
        },
    },
    mounted() {
        this.drawSimplemap();
    },
    methods: {
        drawSimplemap() {
            let gripSimpleMap = new GripGeoJsonSimpleMap("simple-map");
            gripSimpleMap.setGeoJsonUrl(this.gejsonUrl)
                .setKeyPropNm(this.keyProp)
                .setNamePropNm(this.nameProp)
                .setMapScale(this.mapScale)
                .setPathClickHandler((areaCode, areaName, isText) => {
                    this.$eventBus.$emit("SimpleMap::click-simple-map-area");
                })
                .setMapDrawCompletedHandler(() => {
                    this.$eventBus.$emit("SimpleMap::completed-simple-map-draw", gripSimpleMap);
                });
            if(typeof this.center !== $_TYPE.UNDEF) {
                gripSimpleMap.setCenter(this.center);
            } else {
                let localGovLongitude = $_WC.localGovLongitude;
                let localGovLatitude = $_WC.localGovLatitude;
                if($_WC.responsiveScale === 3){
                    localGovLongitude = '127.064313';
                    localGovLatitude = '37.498408';
                }
                gripSimpleMap.setCenter([localGovLongitude, localGovLatitude]);
            }
            gripSimpleMap.drawMap();
        }
    },
}
</script>
